@if (node() && formGroup()) {
<div class="role-panel">
    <form class="role-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div class="body">
            <div class="row">
                <div class="content-field">
                    <app-checkbox [formGroup]="formGroup()!" [meta]="typeMeta"
                        [model]="$safeNavigationMigration(node()?.permit?.dataType)"></app-checkbox>
                </div>
                <div class="content-field">
                    <app-checkbox [formGroup]="formGroup()!" [meta]="schemaMeta"
                        [model]="$safeNavigationMigration(node()?.permit?.schema)"></app-checkbox>
                </div>
                <div class="content-field">
                    <app-checkbox [formGroup]="formGroup()!" [meta]="contentMeta"
                        [model]="$safeNavigationMigration(node()?.permit?.content)"></app-checkbox>
                </div>
                <div class="content-field">
                    <app-checkbox [formGroup]="formGroup()!" [meta]="importMeta"
                        [model]="$safeNavigationMigration(node()?.permit?.import)"></app-checkbox>
                </div>
                <div class="content-field">
                    <app-checkbox [formGroup]="formGroup()!" [meta]="securityMeta"
                        [model]="$safeNavigationMigration(node()?.permit?.security)"></app-checkbox>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
